<!-- desktop template -->
<div *appIsDesktop>
  <app-quotes-subsections-toggles [activeTab]="activeTab.Quotes"></app-quotes-subsections-toggles>

  @if (isLoading) {
    <div id="loadingContainer" class="overlay full">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner id="quotesLoader" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <div id="table-container" class="table-container">
    <ds-paper borderRadius="radius_S" insidePaddingTop="top-spacing_L" insidePaddingBottom="bottom-spacing_L"
      insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">

      @if (dataLoaded.templateValues) {
        <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
          (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="quoteKey"
          [templateValuesType]="templateValues.QuoteType" [label]="appStrings.menu_Quotes" [activeTab]="activeTab.Quotes">
        </app-quotes-subsections-filter-form>
      }
      <div [hidden]="!totalRecords">
        <ds-table mat-table matSort id="openQuotesTable" [dataSource]="quoteList" (matSortChange)="sortData($event)"
            [matSortDisabled]="!totalRecords" [displayedColumns]="displayedColumns" [isWithRadio]="isWithRadio"
            (selectionChange)="onRadioChange($event)">
            <ng-container matColumnDef="accountManager">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ appStrings.quoteDetails_AccountManager }}
              </th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.quoteDetails_AccountManager+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ quote.accountManagerName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{appStrings.accounts_labelName}}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.accounts_labelName+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ quote.accountName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="bpNumber">
              <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_bpLabel}}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.quote_bpLabel+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ quote.bpNumber }}
              </td>
            </ng-container>
            <ng-container matColumnDef="quoteName">
              <th mat-header-cell *matHeaderCellDef>{{ appStrings.quote_quoteName }}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.quote_quoteName+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                @if (quote.quoteName) {
                  <span>{{ quote.quoteName}}</span>
                }
                @if (!quote.quoteName) {
                  <span>—</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="quoteNumber">
              <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_quoteNumber}}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.quote_quoteNumber+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                @if (!quote.migratedQuoteNumber) {
                  <span>
                    {{ quote.quoteNumber }}
                  </span>
                } @else {
                  <span>{{ quote.migratedQuoteNumber }}</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="quoteDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ appStrings.label_quoteDate }}
              </th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.label_quoteDate+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ quote.quoteDate | date: dateFormat }}
              </td>
            </ng-container>
            <ng-container matColumnDef="quoteType">
              <th mat-header-cell *matHeaderCellDef>{{ appStrings.label_type }}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.label_type+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ templateValues.QuoteType[quote.quoteType] }}
              </td>
            </ng-container>
            <ng-container matColumnDef="quoteStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ appStrings.label_status }}</th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.label_status+'_'+index"
                [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ templateValues.QuoteStatus[quote.quoteStatusId] }}
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">
                {{ appStrings.label_total }}
              </th>
              <td mat-cell *matCellDef="let quote;let index = dataIndex" [id]="appStrings.label_total+'_'+index"
                class="total" [ngClass]="{isExpired: quote.quoteStatusId===2}">
                {{ (quote.total) ? (quote.total | currency: quote.currencySign) : '' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let quote; let index = dataIndex">
                <ds-button size="medium" type="tertiary" variant="label-icon" icon="edit-outlined" iconStyle="material-icons-outlined"
                  [id]="'edit_'+index" (onClick)="navigateToQuote(quote.id)" label="{{ appStrings.label_edit }}"
                  iconPosition="left">
                </ds-button>
              </td>
            </ng-container>
        </ds-table>
      </div>

      @if (isPartialLoading) {
        <div id="loadingPartialResults" class="searching-row row-loading"><span id="hourglassLoading"
        class="crm-industrial-font icon-hourglass"></span>{{appStrings.loading_stillSearching}}</div>
      }
      @if (!isLoading && !isPartialLoading && !totalRecords) {
        <div id="no-results" class="no-results">{{appStrings.noEntriesFound}}</div>
      }

      @if (totalRecords > 0) {
        <div id="pagination-container-desktop" class="pagination-container-desktop">
          <div id="page-count" class="page-count">
            @if (!isLoading && !isPartialLoading) {
              <div>
                <b>{{ pageOffset + 1 }} - {{ pageOffset + (quoteList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
              </div>
            }
          </div>
          <div id="pagination-wrapper">
            <ds-pagination
              id="quotes-pagination"
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
          <div class="flex-item-2"></div>
        </div>
      }

    </ds-paper>
  </div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">

  @if (isLoading) {
    <div class="overlay full" id="quotes-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  @if (dataLoaded.templateValues) {
    <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
      (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="quoteKey"
      [templateValuesType]="templateValues.QuoteType" [label]="appStrings.menu_Quotes">
      <app-quotes-subsections-toggles [activeTab]="activeTab.Quotes"></app-quotes-subsections-toggles>
    </app-quotes-subsections-filter-form>
  }

  @for (quote of quoteList; track quote; let i = $index) {
    <mat-expansion-panel class="mobile-card two-columns tall blue-border" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title id="quote-card-header-container" class="card-header-container">
          <span class="card-header">
            <span id="quote-card-title" class="title" [ngClass]="{expired: quote.quoteStatusId===2}">
              {{ quote.accountName ?? '-'}}
            </span>
            <span id="quote-card-subtitle" class="subtitle">
              {{ quote.total | currency: quote.currencySign }}
            </span>
          </span>
          <span class="card-header-action">
            <ds-button size="medium" type="tertiary" variant="icon-only" icon="edit-outlined" iconStyle="material-icons-outlined" [id]="'edit_'+i"
              (onClick)="navigateToQuote(quote.id)">
            </ds-button>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ds-divider></ds-divider>
      <div class="content">
        <div class="row">
          <div class="column">
            <typography [id]="'confidence_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_accountManager }} </typography>
            <typography [id]="'confidence_'+i" variant="body-2" weight="medium"> {{ quote.accountManagerName ?? '-'}} </typography>
          </div>
          <div class="column">
            <typography [id]="'bpNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_bpNumber }} </typography>
            <typography [id]="'bpNumber_'+i" variant="body-2" weight="medium"> {{ quote.bpNumber ?? '-'}} </typography>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <typography [id]="'expireDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_quoteName }} </typography>
            <typography [id]="'expireDate_'+i" variant="body-2" weight="medium"> {{ quote.quoteName ?? '-' }} </typography>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <typography [id]="'confidence_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_quoteNumber }} </typography>
            <typography [id]="'confidence_'+i" variant="body-2" weight="medium"> {{ quote.quoteNumber ?? '-'}} </typography>
          </div>
          <div class="column">
            <typography [id]="'bpNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_quoteDate }} </typography>
            <typography [id]="'bpNumber_'+i" variant="body-2" weight="medium"> {{ quote.quoteDate | date: dateFormat }} </typography>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <typography [id]="'confidence_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_type }} </typography>
            <typography [id]="'confidence_'+i" variant="body-2" weight="medium"> {{ templateValues.QuoteType[quote.quoteType] ?? '-'}} </typography>
          </div>
          <div class="column">
            <typography [id]="'bpNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quote_bpStatusLabel }} </typography>
            <typography [id]="'bpNumber_'+i" variant="body-2" weight="medium" [ngClass]="{expired: quote.quoteStatusId===2}">
              {{ templateValues.QuoteStatus[quote.quoteStatusId] ?? '-'}}
            </typography>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  }
  @if (totalRecords > 0) {
    <div class="pagination-container">
      <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div class="pagination">
          <ds-pagination
            [totalPages]="totalPages"
            paginationDisplay="small"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
      </ds-paper>
    </div>
  }
</div>
